import { render, staticRenderFns } from "./CustomerDetails.vue?vue&type=template&id=4b238952&scoped=true&"
import script from "./CustomerDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetails.vue?vue&type=style&index=0&id=4b238952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b238952",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b238952')) {
      api.createRecord('4b238952', component.options)
    } else {
      api.reload('4b238952', component.options)
    }
    module.hot.accept("./CustomerDetails.vue?vue&type=template&id=4b238952&scoped=true&", function () {
      api.rerender('4b238952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Customer/CustomerDetails.vue"
export default component.exports